<template>
  <div>
    <div class="hover-item" @click="itemClick">
      <span class="navbar-item">
        <span class="icon is-small">
          <i :class="icon"></i>
        </span>
        <span class="pl-1" >
          {{text}}
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'RightItem',
  props: {
    // item: { type: Object }
    link: { type: String },
    icon: { type: String },
    text: { type: String }
  },
  computed: {
    ...mapState(['isLoggedIn', 'userName'])
  },
  methods: {
    itemClick () {
      this.$router.push(this.link)
    }
  }
}
</script>
<style scoped>
div.hover-item :hover{
  background-color: hsl(0, 0%, 96%);
  cursor: pointer;
}
</style>
